

import React from "react";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, productName }) => {
  if (!isOpen) return null; // Do not render the modal if it's not open

  return (
    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-gray-800 bg-opacity-50">
      <div className="relative w-full my-6 mx-auto max-w-md">
        <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none transform transition-all duration-300 scale-95 hover:scale-100">
          <div className="p-6 text-center">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">{productName}</h2>
            <div className="flex justify-center gap-4">
              <button
                onClick={onConfirm}
                className="bg-red-500 text-white font-semibold py-2 px-6 rounded-md transition-transform transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
              >
                Yes, Delete
              </button>
              <button
                onClick={onClose}
                className="bg-gray-300 text-black font-semibold py-2 px-6 rounded-md transition-transform transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50"
              >
                No, Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;


// import React from "react";

// const ConfirmationModal = ({ isOpen, onClose, onConfirm, productName }) => {
//   if (!isOpen) return null; // Do not render the modal if it's not open

//   return (
//     <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-gray-800 bg-opacity-50">
//       <div className="relative w-full my-6 mx-auto max-w-lg">
//         <div className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none transform transition-all duration-300 scale-95 hover:scale-100">
//           <div className="p-8 text-center">
//             <h2 className="text-2xl font-semibold text-gray-800 mb-6">Are you sure you want to delete <span className="text-red-500">{productName}</span>?</h2>
//             <p className="text-gray-600 mb-6">This action cannot be undone.</p>
//             <div className="flex justify-center gap-6">
//               <button
//                 onClick={onConfirm}
//                 className="bg-red-500 text-white font-semibold py-3 px-8 rounded-lg transition-transform transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 shadow-md hover:shadow-lg"
//               >
//                 Yes, Delete
//               </button>
//               <button
//                 onClick={onClose}
//                 className="bg-gray-300 text-black font-semibold py-3 px-8 rounded-lg transition-transform transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50 shadow-md hover:shadow-lg"
//               >
//                 No, Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ConfirmationModal;
